import React from 'react';
import { IOldIconProps } from './type';

const BankAccount: React.FC<IOldIconProps> = ({
  width,
  height,
  color = '#000',
  ...props
}) => {
  return (
    <svg
      width={width || 32}
      height={height || 32}
      viewBox="0 0 32 32"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 6H26C28.2091 6 30 7.79086 30 10V12H2V10C2 7.79086 3.79086 6 6 6ZM6 26H26C28.2091 26 30 24.2091 30 22V14H2V22C2 24.2091 3.79086 26 6 26ZM5.25 19C5.25 18.5858 5.58579 18.25 6 18.25H12C12.4142 18.25 12.75 18.5858 12.75 19C12.75 19.4142 12.4142 19.75 12 19.75H6C5.58579 19.75 5.25 19.4142 5.25 19Z"
        fill={color}
      />
    </svg>
  );
};

export default BankAccount;
